import AxiosControl from '../components/axios/AxiosControl'
import { getErrorMessage, getResponseData, isSuccessResponse } from '../helpers/apiResponse'
const Axios = AxiosControl()

export const getProductHistory = (productId, page = 1, limit = 25) => async (dispatch) => {
    dispatch({
        type: 'PRODUCTHISTORY_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/product/history/'+ productId, { page, limit }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCTHISTORY_GET_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCTHISTORY_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const resetProductHistoryResult = () => (dispatch) => {
    dispatch({
        type: 'PRODUCTHISTORY_RESET_RESULT'
    })
}
